module.exports = __webpack_public_path__ + "img/notary-journal_B09JR7ZL8D.1573f3be.jpg";